/** This file is auto generated by convertSvgToJsx.ts */

import React from 'react'
const coins_3 = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="none"
    viewBox="0 0 17 17"
    {...props}
  >
    <path
      stroke="#000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M14.646 3.923v3.139m-1.395-1.57h2.964M3.138.785v3.138M1.57 2.353h3.139m.732 10.462h6.835c.27 0 .488.219.488.489v2.162c0 .27-.219.488-.488.488H5.44a.488.488 0 0 1-.488-.488v-2.162c0-.27.218-.489.488-.489Zm.976-3.138h6.835c.27 0 .489.218.489.488v2.162c0 .27-.22.488-.489.488H6.416a.488.488 0 0 1-.488-.488v-2.162c0-.27.219-.488.488-.488Zm-2.93-3.139h6.835c.27 0 .488.219.488.489v2.162c0 .27-.218.488-.488.488H3.487A.488.488 0 0 1 3 9.189V7.027c0-.27.219-.489.488-.489Z"
    />
  </svg>
)
export default coins_3
